<template>
  <analytics-sub-page
    title="Rewards Analytics"
    icon="gift"
    css-class="analytics-rewards"
    default-label="Rewards"
    :section-specs="sectionSpecs"
  >
    <rewards-metrics ref="rewardsRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import RewardsMetrics from '@/pages/analyticsApp/components/RewardsMetrics.vue';

const rewardsRef = ref(null);

const sectionSpecs = [{ key: 'rewards', label: 'Rewards', ref: rewardsRef }];
</script>
